var common = require("../../../utiles/common.js");
require("./index.less");

module.exports = {
  register: function () {
    document.createElement("wechat-msg");
    ko.components.register("wechat-msg", {
      viewModel: function (params) {
        var $this = this;
        var query = common.urlSearch(location.href);
        $this.message = decodeURI(query["message"]);
        if (query["message"]) {
          delete query.message;
        }
        var param = common.objToSearchUrl(query)
          ? "?" + common.objToSearchUrl(query)
          : "";
        console.log(param);
        $this.goLogin = function () {
          window.location.href = "/#/login" + param;
        };
      },
      template: require("./WechatMsg.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/component/login/wechatMsg/index.js
// module id = 202
// module chunks = 0